import { render, staticRenderFns } from "./Internet.vue?vue&type=template&id=027a4dd5&scoped=true"
import script from "./Internet.vue?vue&type=script&lang=js"
export * from "./Internet.vue?vue&type=script&lang=js"
import style0 from "./Internet.vue?vue&type=style&index=0&id=027a4dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a4dd5",
  null
  
)

export default component.exports